import { FormControl, FormHelperText, MenuItem, Select } from '@mui/material';
import { Box } from '@mui/system';
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarExport,
  GridToolbarDensitySelector
} from '@mui/x-data-grid';
import { useEffect, useState } from 'react';
import { usePapaParse } from 'react-papaparse';

const initialState = {
  data: [],
  filtered: [],
  country: '',
  food: ''
};

let countries = [];
let foods = [];

const FilteredDataGrid = (props) => {
  const csv = props.csv;
  const { readString } = usePapaParse();
  const [state, setState] = useState(initialState);

  const handleReadString = () => {
    readString(csv, {
      complete: (results) => {
        const data = results.data;
        data.forEach((d, idx) => {
          d.id = idx;
        });

        data.forEach((d) => {
          if (d['Country of origin of the sample taken'] && !countries.includes(d['Country of origin of the sample taken'])) {
            countries.push(d['Country of origin of the sample taken']);
          }
          if (d['Food commodity'] && !foods.includes(d['Food commodity'])) {
            foods.push(d['Food commodity']);
          }
        });

        countries = countries.filter(Boolean).sort((a, b) => a.localeCompare(b));
        foods = foods.filter(Boolean).sort((a, b) => a.localeCompare(b));

        const country = countries[0];
        const food = foods[0];
        const filtered = data.filter(
          (d) => d['Country of origin of the sample taken'] === country
        );

        setState({
          data,
          filtered,
          country,
          food
        });
      },
      download: true,
      header: true,
      dynamicTyping: true,
      error: (error, file) => {
        console.log('Error while parsing:', error, file);
      }
    });
  };

  useEffect(() => {
    handleReadString();
  }, []);

  const handleCountrySelectChange = (event) => {
    const country = event.target.value;
    const filtered = state.data.filter(
      (d) => d['Country of origin of the sample taken'] === country
    );

    setState((prevState) => ({
      ...prevState,
      filtered,
      country
    }));
  };

  const handleFoodSelectChange = (event) => {
    const food = event.target.value;
    const filtered = state.data.filter(
      (d) =>
        d['Country of origin of the sample taken'] === state.country &&
        d['Food commodity'] === food
    );

    setState((prevState) => ({
      ...prevState,
      filtered,
      food
    }));
  };

  const cols = [
    {
      field: 'Report name',
      headerName: 'Pesticide',
      flex: 1,
      minWidth: 100
    },
    {
      field: 'Food commodity',
      headerName: 'Food commodity',
      flex: 1,
      minWidth: 100
    },
    {
      field: 'Total number of results with Sample in report',
      type: 'number',
      headerName: 'Total number of results',
      flex: 1,
      minWidth: 100
    },
    {
      field: '% Results non compliant for pesticides',
      type: 'number',
      headerName: 'Non compliant',
      flex: 1,
      minWidth: 100
    }
  ];

  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <GridToolbarColumnsButton
          sx={{
            color: '#1F2442',
            span: { marginTop: '0', marginRight: { xs: '0', sm: '5px' } }
          }}
        />
        <GridToolbarFilterButton
          sx={{
            color: '#1F2442',
            span: { marginTop: '0', marginRight: { xs: '0', sm: '5px' } }
          }}
        />
        <GridToolbarDensitySelector
          sx={{
            color: '#1F2442',
            span: { marginTop: '0', marginRight: { xs: '0', sm: '5px' } }
          }}
        />
        <GridToolbarExport
          sx={{
            color: '#1F2442',
            span: { marginTop: '0', marginRight: { xs: '0', sm: '5px' } }
          }}
        />
      </GridToolbarContainer>
    );
  }

  return (
    <Box sx={{ height: 400, maxWidth: { xs: '330px', sm: '100%' } }}>
      <Box>
        <FormControl sx={{ m: 1, minWidth: 120 }}>
          <FormHelperText>Select country of origin</FormHelperText>
          <Select
            value={state.country}
            onChange={handleCountrySelectChange}
            sx={{
              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: '#22294D'
              },
              width: '100%'
            }}
          >
            {countries.map((c, idx) => (
              <MenuItem key={idx} value={c}>
                {c}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
      {countries.length > 0 && (
        <DataGrid
          columns={cols}
          rows={state.filtered}
          components={{
            Toolbar: CustomToolbar
          }}
        />
      )}
    </Box>
  );
};

export default FilteredDataGrid;
